import Vue from 'vue';
import Router from 'vue-router';

const Register = r => require.ensure([], () => r(require('./Register/Register.vue')), 'Register');
const Result = r => require.ensure([], () => r(require('./Register/Result.vue')), 'Register');
const Change = r => require.ensure([], () => r(require('./Password/Change.vue')), 'Password');
const Forget = r => require.ensure([], () => r(require('./Password/Forget.vue')), 'Password');
const ChangeBoundPhone = r => require.ensure([], () => r(require('./ChangeBoundPhone/ChangeBoundPhone.vue')), 'Password');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/Register',
      name: 'Register',
      component: Register
    }, {
      path: '/Change',
      name: 'Change',
      component: Change
    }, {
      path: '/Forget',
      name: 'Forget',
      component: Forget
    }, {
      path: '/Result',
      name: 'Result',
      component: Result
    }, {
      path: '/ChangeBoundPhone',
      name: 'ChangeBoundPhone',
      component: ChangeBoundPhone
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/AccountSystem/router.js